import { Control, Controller } from 'react-hook-form';
import { Form, FormFieldProps } from 'semantic-ui-react';

interface Props extends FormFieldProps {
  controllerControl: Control<any>;
  controllerName: string;
  required?: boolean;
  isNotUpperCase?: boolean;
}

export function ControllerFormField({
  controllerControl,
  controllerName,
  required,
  isNotUpperCase,
  ...rest
}: Props) {
  return (
    <Controller
      control={controllerControl}
      name={controllerName}
      rules={{
        required,
      }}
      render={({ field: { onChange, onBlur, value } }) => (
        <Form.Field
          {...rest}
          value={value}
          onChange={(_: any, data: any) =>
            onChange(isNotUpperCase ? data.value : data.value.toUpperCase())
          }
          onBlur={onBlur}
          required={required}
        />
      )}
    />
  );
}
